import ListWidgetMixin from "../../mixins/ListWidgetMixin";

Vue.asyncComponent('ak-popover-menu-group', {
    name: 'ak-popover-menu-group',
    mixins: [ListWidgetMixin],
    data() {
        return {
            open: false,
            showConfirm: false,
            isOpen: false
        }
    },
    props: {
        title: {
            type: String,
            required: false,
        },
        active: {
            type: Boolean,
            required: false,
        },
        colorMode: {
            type: String,
            required: false,
        },
        icon: {
            type: String,
            required: false,
        },
        image: {
            type: String,
            required: false,
        },
        description: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
        },
        showDivider: {
            type: Boolean,
            required: false,
        },
        items: {
            type: Array,
            required: false,
        },
    },
    computed: {
        /**
         * Show arrow if we have items
         * @return {number}
         */
        showArrow() {
            return this.items.length;
        },
    },
    methods: {
        /**
         * Toggle group open on click
         * @param e
         */
        click(e) {
            e.preventDefault();
            this.isOpen = ! this.isOpen;

            this.$parent.$children.forEach($childComponent => {
                if ($childComponent.$options.name === 'ak-popover-menu-group' && $childComponent !== this) {
                    $childComponent.isOpen = false;
                }
            })
        }
    },
}, 'layout/partials/ak-popover-menu-group.html');